import React from 'react';
import Route from './pages/Route';	

import "./assets/css/style.css";
//import "./assets/css/skin/skin-2.css";
import "swiper/css";


// function loadSkin(skinName) {
//   const link = document.createElement('link');
//  // link.rel = 'stylesheet';
//   //link.type = 'text/css';
//   link.href = `${skinName}.css`;
//   document.head.appendChild(link);
// }


function App() {
  return (
    <>
     {/* <button onClick={() => loadSkin('skin-4')}>Load Skin 1</button> */}
		  <Route />
    </>
  );
}

export default App;
